export function getAll() {
  let items = [
    {
      value: 0,
      name: "All",
      text: "全部",
    },
    {
      value: 1,
      name: "Send",
      text: "開立",
    },
    {
      value: 2,
      name: "Void",
      text: "作廢",
    },
  ];
  return items;
}
